import axiosvl from "../axios/axios-vl.js";

export default {
    methods: {
        mx_getCustomerInformation() {
            axiosvl.post(this.$store.getters['api/get_customer_info_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;

                if (fields.RESULTCOD.value === 'OK') {
                    this.$store.dispatch("setCustomerDetails", {
                        "allowbackorder": fields.CMBOCD.value,
                        "defaultcarrier": fields.CMCARR.value,
                    });
    
                    this.$store.dispatch('cart/po_required', {
                        po_required : fields.CMPORQ.value
                    });
                    
                    // store to state - billing details
                    this.$store.dispatch('cart/billingdetails', {
                        "email":  fields.ECEMAL.value,
                        "billingname": fields.ADNAME.value,
                        "billingaddress1": fields.ADADD1.value,
                        "billingaddress2": fields.ADADD2.value,
                        "billingcity": fields.ADCITY.value,
                        "billingstate": fields.ADSTTC.value,
                        "billingzip": fields.ADZIPC.value,
                        "billingphone": fields.ADPHON.value,
                    });

                    // store to state - tax rate for B2C
                    if (this.$store.getters.customerIndicator == 'C'){
                        this.mx_getTaxRate(fields.ADZIPC.value, fields.ADSTTC.value);
                    }

                    // if the logged in customer is B2B
                    // get the customer enrolled info
                    if (this.$store.getters.customerIndicator == 'B'){
                        this.mx_getCustomerEnrolled();
                    }

                    // store to state - default location of the user
                    this.mx_getDefaultLocationDetails(fields.CMDLOC.value);

                } 

                this.isloading = false;
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },
        mx_getCustomerEnrolled() {
            axiosvl.post(this.$store.getters['api/get_customer_enrolled_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const custlocs = [];

                // save the locations to the state
                // customer locations is being used in multiple locations stock check to sort the locations
                if (fields.RESULTCOD.value === 'OK') {
                    for (const key in response.data.webroutine.lists.LOCS.entries) {
                        const obj = response.data.webroutine.lists.LOCS.entries[key];
                        custlocs.push(obj);
                    }
                    // console.log(custlocs);
                    this.$store.dispatch("setcustB2BLocations", custlocs);
                    
                    this.$store.dispatch("setcustInfoEnrolled", {
                        ECDXR : fields.ECDXR.value,
                        ECLSLG : fields.ECLSLG.value,
                    });
                }
                
                this.isloading = false;
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },
        mx_getTaxRate(zip, state){

            if(!zip || !state){
                return false;
            }

            const tax_rate_uri = this.$store.getters['api/tax_rate_uri'];
            const params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "HOSTURL": {
                            "value": this.$store.getters.hosturl
                        },
                        "LW3TZIPCD": {
                            "value": this.billingzip
                        },
                        "LW3TXSTAT": {
                            "value": this.billingstate
                        },
                    }
                }
            };

            axiosvl.post(tax_rate_uri, params).then((response) => {
                const fields = response.data.webroutine.fields
                this.tax_rate = parseFloat(fields.LW3TXRATE.value) + 1;

                this.$store.dispatch("cart/update_tax_rate", {tax_rate : fields.LW3TXRATE.value});

                if(this.totals !== undefined){
                    const with_tax = parseFloat(this.totals[0].ordertotal) * this.tax_rate;
                    const tax_amount = with_tax - parseFloat(this.totals[0].ordertotal);

                    this.totals[0].taxtotal = tax_amount;
                    this.totals[0].ordertotal = with_tax;
                    this.$store.dispatch("cart/totals", this.totals[0]);
                }
                
            })
            .catch((error) => {
                // this.isloading = false;
                console.log("error - " + error);
            });
        },
        mx_getCustomerInformation_bk() {
            axiosvl.post(this.$store.getters['api/get_customer_info_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;

                if (fields.RESULTCOD.value === 'OK') {
                    this.$store.dispatch("setCustomerDetails", {
                        "allowbackorder": fields.CMBOCD.value,
                        "defaultcarrier": fields.CMCARR.value,
                    });
                    this.mx_getDefaultLocationDetails(fields.CMDLOC.value);
                } 

                this.isloading = false;
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },

        /** get default locations
         * fetch all the locations in wd.locations API
         * search from the response the location of the user logged in
         */
        mx_getDefaultLocationDetails(locationid) {
            axiosvl.post(this.$store.getters['api/wd_locations_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;

                if (fields.RESULTCOD.value === 'OK') {
                    let list =  response.data.webroutine.lists.LOCS.entries.find((loc) => (loc.LCLOC === locationid));

                    if (list != undefined) {
                        this.$store.dispatch("setDefaultLocationDetails", {
                            "defaultlocationid": list.LCLOC,
                            "defaultlocationname": list.LCNAME,
                            "defaultlocationcity": list.ADCITY,
                            "defaultlocationstate": list.ADSTTC,
                        });
                    }
                    // for (const key in response.data.webroutine.lists.PARTS.entries) {
                    //     const obj = response.data.webroutine.lists.PARTS.entries[key];
                    
                } 

                this.isloading = false;
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        }
    }
}